import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Switch, FormControlLabel, Chip } from '@mui/material';
import { AddComment } from '@mui/icons-material';

const TaskRemarkUpdate = ({ callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");

    const handleUpdate = () => {
        if (!remark.trim()) return; // Don't allow empty remarks

        if (callBack) {
            callBack({
                remark: remark,
                notify: notify
            });
        }
        setDialogStatus(false);
        setRemark(""); // Reset
    };

    return (
        <>
            {/* The Trigger: A button-style Chip */}
            <Chip 
                icon={<AddComment style={{ fontSize: '16px' }} />}
                label="Add Remark"
                onClick={() => setDialogStatus(true)}
                variant="outlined"
                color="primary"
                sx={{ 
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    '& .MuiChip-label': { px: 1 }
                }} 
            />

            <Dialog
                open={dialogStatus}
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="xs"
            >
                <div className='p-3 fw-bold border-bottom'>Add Task Remark / Comment</div>
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Your Remark"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                margin="normal"
                                placeholder="Type your update or comment here..."
                                autoFocus
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={notify}
                                        onChange={(e) => setNotify(e.target.checked)}
                                    />
                                }
                                label="Notify team via email"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                    <button 
                        className='btn btn-primary' 
                        onClick={handleUpdate}
                        disabled={!remark.trim()}
                    >
                        Post Remark
                    </button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TaskRemarkUpdate;